import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

const ApiClientsApp = lazy(() => import('~/apps/api-clients/api-clients'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.API_CLIENTS);

  useOnLoad(() => {
    const title = t('API_CLIENTS_PAGE_TITLE', { defaultValue: 'API Clients' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.API_CLIENTS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.ApiClients }
    });
    track({
      type: 'page_view',
      payload: { ...GenerateBaseAnalyticsPayload([]), page: RoutingConstants.ApiClients }
    });
  });

  return (
    <Tagged tag="screen-api-clients">
      <Suspense>
        <P2GBox>
          <ApiClientsApp />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'API Clients';
